var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-component collapse",class:{expanded: _vm.show}},[_c(_vm.headingTag,{tag:"component",staticClass:"heading",on:{"click":_vm.toggleHeading}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"body"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }